import { createUseFetchHook } from '@tls/ui-request';

import { errorNotification, successNotification } from '../notification/store/actions';

export default createUseFetchHook({
  errorNotification,
  successNotification,
});
